export default "__VITE_ASSET__D6q142Qy__"